/**
 * @name RfidDebugInfo
 * @description Componente de debug para monitorar captura RFID
 * @author Keven Adan Bezerra | kevenadanb
 */

import { Box, Chip, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

interface RfidDebugInfoProps {
  rfidCapture: any;
  realValue: string;
  processedValue: string;
}

const RfidDebugInfo: React.FC<RfidDebugInfoProps> = ({
  rfidCapture,
  realValue,
  processedValue,
}) => {
  const [bufferState, setBufferState] = useState({
    buffer: "",
    length: 0,
    isReading: false,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      if (rfidCapture) {
        setBufferState(rfidCapture.getBufferState());
      }
    }, 100);

    return () => clearInterval(interval);
  }, [rfidCapture]);

  // Só mostra em desenvolvimento
  if (process.env.NODE_ENV !== "development") {
    return null;
  }

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 10,
        right: 10,
        p: 2,
        bgcolor: "rgba(0,0,0,0.8)",
        color: "white",
        borderRadius: 2,
        fontSize: "12px",
        maxWidth: 300,
        zIndex: 9999,
      }}
    >
      <Typography variant="subtitle2" gutterBottom>
        📡 Debug RFID
      </Typography>

      <Box sx={{ mb: 1 }}>
        <Typography variant="caption">Buffer:</Typography>
        <Chip
          label={bufferState.buffer || "(vazio)"}
          size="small"
          sx={{ ml: 1, fontSize: "10px" }}
        />
      </Box>

      <Box sx={{ mb: 1 }}>
        <Typography variant="caption">Comprimento:</Typography>
        <Chip
          label={bufferState.length}
          size="small"
          color={bufferState.length > 0 ? "primary" : "default"}
          sx={{ ml: 1, fontSize: "10px" }}
        />
      </Box>

      <Box sx={{ mb: 1 }}>
        <Typography variant="caption">Status:</Typography>
        <Chip
          label={bufferState.isReading ? "Lendo" : "Aguardando"}
          size="small"
          color={bufferState.isReading ? "success" : "default"}
          sx={{ ml: 1, fontSize: "10px" }}
        />
      </Box>

      <Box sx={{ mb: 1 }}>
        <Typography variant="caption">Valor Real:</Typography>
        <Typography variant="body2" sx={{ fontFamily: "monospace" }}>
          "{realValue}"
        </Typography>
      </Box>

      <Box>
        <Typography variant="caption">Processado:</Typography>
        <Typography variant="body2" sx={{ fontFamily: "monospace" }}>
          "{processedValue}"
        </Typography>
      </Box>
    </Box>
  );
};

export default RfidDebugInfo;
